document.addEventListener("DOMContentLoaded", function () {
  const marquees = document.querySelectorAll(".marqueelines h2");
  const speeds = [20, 15, 20]; // Speed in seconds; second line is faster

  marquees.forEach((marquee, index) => {
    const width = marquee.clientWidth; // Get the width of the element

    function animateMarquee() {
      marquee.style.transition = "none"; // Reset transition to adjust position instantly
      marquee.style.left = "10%"; // Start from right outside the screen

      setTimeout(() => {
        marquee.style.transition = `left ${speeds[index]}s linear`; // Apply speed-specific transition
        marquee.style.left = `-${width}px`; // Move to the left outside the screen
      }, 100);

      marquee.addEventListener("transitionend", animateMarquee); // Re-trigger the animation continuously
    }

    animateMarquee(); // Start the animation
  });
});
